import {tns} from "tiny-slider/src/tiny-slider";

import {product} from "./modules/product.js";
import {recommend} from "./modules/recommended-products.js";
import {toggle} from "./modules/toggle.js";
import {productReviews} from './modules/reviews.js';

if (document.getElementById('AddToCartForm') != null) {
	product();
	recommend();
}

if (document.getElementById('product-gallery') != null) {
  tns({
    "container": "#product-gallery",
    "items": 1,
    "mouseDrag": true,
    "navContainer": "#product-thumbnails",
    "navAsThumbnails": true,
    "autoplay": false,
    "swipeAngle": 15,
    "speed": 400,
    "controls": false
  });
} 

productReviews();

// Toggle
toggle();